import { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import { GetPeriodTimeByPayrollId, cleanUpPeriodTimeList } from '@store/HR/Payroll/runPayrollSlice';

const useGetPeriodTimeByPayroll = (payrollId, assignmentId) => {
  const dispatch = useDispatch();

  useEffect(() => {
    if (payrollId && assignmentId) {
      // dispatch(GetPeriodTimeByPayrollId(payrollId));
      dispatch(GetPeriodTimeByPayrollId({ PayrollId: payrollId, AssignmentId: assignmentId }));
    } else if (payrollId) {
      dispatch(GetPeriodTimeByPayrollId({ PayrollId: payrollId }));
    }

    // return () => {
    //   dispatch(cleanUpPeriodTimeList());
    // };
  }, [dispatch, payrollId]);

  const {
    PeriodTimeList,
    loadingPeriodTimeList: loading,
    errorPeriodTimeList: error
  } = useSelector(state => state.runPayroll);

  const optionPeriodTime = PeriodTimeList?.map(item => ({
    value: item.id,
    label: item.periodName,
    id: item.id,
    name: item.periodName,
    hasRun: item.hasRun,
    payrollName: item.periodName
  }));

  return { PeriodTimeList, optionPeriodTime, loading, error };
};

export default useGetPeriodTimeByPayroll;
